import React from "react";
function Staff(props) {
  return (
    <li className="item item-container">
      <div className="attribute staff-name">{props.name}</div>
      <div className="attribute staff-title">{props.title}</div>
      <div className="attribute staff-department">{props.department}</div>
      {props.children}
      <div className="attribute staff-email">
        {props.emails.map(addr => (
          <a href={`mailto:${addr.trim()}`}>{addr.trim()}</a>
        ))}
      </div>
    </li>
  );
}
export default Staff;
